import $beaver from 'beaver-logger';

const $loggerInit = ({ loggerEndpoint, token }) => {
  $beaver.init({
    // Log levels which trigger an auto-flush to the server
    autoLog: ['error', 'warn'],

    // Interval at which to debounce $beaver.flush calls
    debounceInterval: 10,

    // Interval at which to automatically flush logs to the server
    flushInterval: 20000,

    // Enable or disable heartbeats, which run on an interval
    heartbeat: false,

    // Heartbeat log interval
    heartbeatInterval: 5000,

    // Maximum number of sequential heartbeat logs
    heartbeatMaxThreshold: 50,

    // Monitors for event loop delays and triggers a toobusy event
    heartbeatTooBusy: false,

    // Event loop delay which triggers a too busy event
    heartbeatTooBusyThreshold: 10000,

    // State name to post logs under
    initial_state_name: 'INIT_WEASLEY',

    // Log performance stats from the browser automatically?
    logPerformance: false,

    // Log window.onunload and window.beforeUnload events?
    logUnload: true,

    // Log unload synchronously, to guarantee the log gets through?
    logUnloadSync: true,

    // Supress `console.log`s when `true`
    silent: process.env.NODE_ENV !== 'development',

    // Limit on number of logs before auto-flush happens
    sizeLimit: 100,

    // URI to post logs to
    uri: loggerEndpoint,
  });

  // add the app-name header to all log events
  $beaver.addHeaderBuilder(() => ({
    'x-app-name': 'checkoutuinodeweb_onboarding_lite',
  }));

  $beaver.addMetaBuilder(() => ({ token }));

  // append EC token to the payload for all log events
  $beaver.addPayloadBuilder(() => ({ token }));
};

export { $loggerInit };
